'use strct';

export default class Banner {
	constructor() {
        (function($){
		if($('.home-banner').length > 0){
		
			if( $(window).width() > 769) { // desktop
				
				$(".banner-slider").slick({
					accessibility: true,
					infinite: true,
					autoplay: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows : false,
					focusOnSelect: true,
					adaptiveHeight: false
				}).on('afterChange',function(){
					$(".slick-cloned").addClass('sharpen');
					$('.lazy').lazyload();
					
				})
				
				var $Clone1 = $('.banner-slider .slick-cloned:first-child');
				var $Clone2 = $('.banner-slider .slick-cloned:last-child');
				
				$Clone1.css('background-image','url(' + $Clone1.data('src') + ')');	
				$Clone2.css('background-image','url(' + $Clone2.data('src') + ')');

			} else {// mobile

				$('.field--name-field-homepage-banner').each(function(){
					var $mobile = $(this).data('mobile'),
						$mobileIMG = $(this).find('img').data('mobile');

					$(this).attr("data-src", $mobile);
					$(this).find('img').attr('src',$mobileIMG);
					
				});
				
				$(".banner-slider").slick({
					accessibility: true,
					infinite: true,
					autoplay: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows : false,
					focusOnSelect: true,
					adaptiveHeight: false
				}).on('afterChange',function(){
					$(".slick-cloned").addClass('sharpen');
					$('.lazy').lazyload();
				})
				
				var $mobileClone1 = $('.banner-slider .slick-cloned:first-child');
				var $mobileClone2 = $('.banner-slider .slick-cloned:last-child');
				
				$mobileClone1.css('background-image','url(' + $mobileClone1.data('mobile') + ')');	
				$mobileClone2.css('background-image','url(' + $mobileClone2.data('mobile') + ')');
			}	
			
			$(window).on("orientationchange",function() {
				if($(window).width() > 800){ // desktop
					console.log('ipad portrait')
					$('.field--name-field-homepage-banner').each(function(){
						var $mobile = $(this).data('mobile'),
							$mobileIMG = $(this).find('img').data('mobile');

						$(this).attr("data-src", $mobile);
						$(this).find('img').attr('src',$mobileIMG);

					});	
					
					var $mobileClone1 = $('.banner-slider .slick-cloned:first-child');
					var $mobileClone2 = $('.banner-slider .slick-cloned:last-child');

					$mobileClone1.css('background-image','url(' + $mobileClone1.data('mobile') + ')');	
					$mobileClone2.css('background-image','url(' + $mobileClone2.data('mobile') + ')');
				} else {
					console.log('ipad landscape')
					$('.field--name-field-homepage-banner').each(function(){
						var $desktop = $(this).data('desktop'),
							$desktopIMG = $(this).find('img').data('desktop');

						$(this).attr("data-src", $desktop);
						$(this).find('img').attr('src',$desktopIMG);

					});	
					
					var $Clone1 = $('.banner-slider .slick-cloned:first-child');
					var $Clone2 = $('.banner-slider .slick-cloned:last-child');

					$Clone1.css('background-image','url(' + $Clone1.data('src') + ')');	
					$Clone2.css('background-image','url(' + $Clone2.data('src') + ')');
					
				}
			})

		}
        })(jQuery);
	}
}